import { useDownload } from '~/common/hooks/useDownload';
import { Button } from '~/common/components/ui/button';
import { DownloadIcon } from 'lucide-react';
import { CircularProgress } from '~/common/components/CircularProgress';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

interface DownloadButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  url: string;
  icon?: ReactNode;
}

export const DownloadButton = forwardRef<HTMLButtonElement, DownloadButtonProps>(
  ({ name, url, icon, ...props }, ref) => {
    const { download, isDownloading } = useDownload();

    return (
      <Button
        {...props}
        ref={ref}
        variant={'ghost'}
        type={'button'}
        disabled={isDownloading}
        onClick={() => {
          download(url, `${name}`);
        }}
        className="flex items-center justify-center p-2 border-none"
      >
        {isDownloading ? <CircularProgress size={'md'} /> : (icon ?? <DownloadIcon />)}
      </Button>
    );
  }
);

DownloadButton.displayName = 'DownloadButton';
